<template>
  <div class="sm:grid sm:grid-cols-[1fr_max-content] gap-6">
    <div class="contents sm:flex sm:justify-center sm:flex-col">
      <h1
        class="font-wix-made-for-display font-semibold text-[2rem] leading-10 sm:text-[2.5rem] md:text-[3rem] md:leading-[3.75rem] md:max-w-[42.5rem]">
        Think smart -  <span class="dark:text-interactive-primary text-t-link" style="font-style: italic;">copy the success</span> of top traders!</h1>
      <router-link class="text-subtitle4 text-t-link hover:text-t-linkHover inline-flex items-center mt-6"
        to="/referral-program">
        View referral rules
        <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" class="h-5 w-5">
          <path
            d="M7.66675 3.33332C7.66675 2.96513 7.96522 2.66666 8.33341 2.66666H12.5303C12.9721 2.66666 13.3303 3.02483 13.3303 3.46666V7.66666C13.3303 8.03485 13.0318 8.33332 12.6636 8.33332C12.2954 8.33332 11.9969 8.03485 11.9969 7.66666V4.9428L7.31149 9.62825C7.05114 9.8886 6.62903 9.8886 6.36868 9.62825C6.10833 9.36791 6.10833 8.9458 6.36868 8.68545L11.0541 3.99999H8.33341C7.96522 3.99999 7.66675 3.70151 7.66675 3.33332Z"
            fill="currentColor"></path>
        </svg>
      </router-link>
    </div>
    <img
      class="px-5 mt-6 w-full max-w-[13.375rem] sm:mt-0 sm:w-[15rem] sm:px-0 sm:max-w-none md:w-[16.75rem] hero-img-desktop"
      width="174" height="168" alt="Referral Background Image" src="/index_files/referral-bg.svg">
    <img
      class="px-5 mt-6 w-full max-w-[100%] sm:mt-0 sm:w-[100%] sm:px-0 sm:max-w-none md:w-[100%] hero-img-mobile"
      width="174" height="168" alt="Referral Background Image" src="/index_files/referral-bg-mobile.svg">
  </div>
</template>

<script>
export default {
  name: 'LandingPageHeroSection'
}
</script>

<style scoped>
.hero-img-desktop {
  display: none;
}

.hero-img-mobile {
  display: block;
}

@media (min-width: 768px) {
  .hero-img-desktop {
    display: block;
  }
  
  .hero-img-mobile {
    display: none;
  }
}
</style>

